import {
    ODataHeader,
    ODataString,
    ODataDecimal,
    ODataDate,
    ODataBoolean
} from "pbas-vue-components";

import { translateProperty } from '../trans'
import store from '@/store'

const DownloadCategoriesHeaders = [
    new ODataHeader({
        title: "Id",
        type: new ODataString("Id"),
        sortable: true,
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false,
        version: 1
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/Name", {
            getString: function(item) {
                const lang = store.getters['common/language']
                return translateProperty(item, 'Name', lang.language);
            }
        }),
        sortable: false,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/LanguageCode"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/Id"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Icon/Svg"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Icon/Id"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Icon/PlanId"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    // new ODataHeader({
    //     title: "globals.name",
    //     type: new ODataString("Coverages[]"),
    //     sortable: false,
    //     visible: false,
    //     allowVisibilityChange: false,
    //     searchable: false
    // }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("PlanId"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.priority",
        type: new ODataDecimal("Order"),
        sortable: true,
        version: 1
    }),
    new ODataHeader({
        type: new ODataString("ClassDownloadCategoryRelations[]/DownloadCategoryId"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        type: new ODataString("ClassDownloadCategoryRelations[]/ClassDownloadCategoryId"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.class",
        type: new ODataString("ClassDownloadCategoryRelations[]/ClassDownloadCenterCategory/Class"),
        visible: true,
        allowVisibilityChange: true,
        searchable: true,
        sortable: true,
        version: 1
    }),
    new ODataHeader({
        type: new ODataBoolean("AllowedGuest"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
];
export default DownloadCategoriesHeaders;